import { useTranslation } from 'react-i18next';

import { IChannel } from '@/entities/channel';
import { useNotifications } from '@/shared/ui/Notifications';

import { useUpdateChannel } from './useUpdateChannel';

interface IUpdateChannelNameData {
  channelId: string;
  name?: string;
}

export function useChannelName() {
  const { updateChannel, ...updateChannelMutation } = useUpdateChannel();
  const { addNotification } = useNotifications();
  const { t } = useTranslation();

  const handleOnSuccess = () => {
    addNotification({
      type: 'success',
      title: t('channels:settings.notifications.success'),
    });
  };

  const getChannelName = (channel: IChannel) => {
    if (channel.name) return channel.name;

    if (channel.phone_number) return channel.phone_number;

    return channel.id;
  };

  const updateChannelName = async (
    data: IUpdateChannelNameData
  ): Promise<IChannel> => {
    return updateChannel(data, handleOnSuccess);
  };

  const setChannelNameMutation = {
    updateChannelName,
    ...updateChannelMutation,
  };

  return { getChannelName, setChannelNameMutation };
}
